import _slicedToArray from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import { LoadingIndicator } from '@spotify-internal/encore-web';
import { ContentList } from '../../ContentList';
import { itemToSearchHit } from '../../Search';
import { gray90 } from '@spotify-internal/encore-foundation';
import { useLocale, useT } from '@mrkt/features/i18n';
import { useRouter } from 'next/router';
import { jsx as _jsx } from "react/jsx-runtime";
export var EventListModule = function EventListModule(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      events = _React$useState2[0],
      setEvents = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      filters = _React$useState4[0],
      setFilters = _React$useState4[1];

  var router = useRouter();
  var t = useT();
  var locale = useLocale();
  var today = new Date().toString();
  var oneDay = 86400000;
  React.useEffect(function () {
    var filteredEvents = items.map(function (item) {
      return itemToSearchHit(item, locale);
    }).filter(Boolean).filter(function (item) {
      return item.date && Date.parse(item.date) >= Date.parse(today) - oneDay;
    }).sort(function (a, b) {
      // TODO Handle these exclamation points
      return Date.parse(a.date) - Date.parse(b.date);
    });
    setEvents(filteredEvents);
    var franchiseFilters = Array.from(new Set(filteredEvents.map(function (_ref2) {
      var label = _ref2.label;
      return label;
    }))).filter(Boolean).sort();
    var locationFilters = Array.from(new Set(filteredEvents.map(function (_ref3) {
      var location = _ref3.location;
      return location;
    }))).filter(Boolean).sort();
    setFilters([{
      filterValue: 'label',
      allLabel: t('FRODOR_c2b5a2', 'All event types', ''),
      filterOptions: franchiseFilters
    }, {
      filterValue: 'location',
      allLabel: t('FRODOR_e5a2b3', 'All locations', ''),
      filterOptions: locationFilters
    }]);
  }, [items]);
  var emptyMessage = (events === null || events === void 0 ? void 0 : events.length) === 0 && router && router.query && router.query._lqa === 'showEmpty' ? t('FRODOR_ddeaa1', 'We currently do not have any upcoming events.', '') : t('FRODOR_05e63d', 'No events matched the specified filters.', '');
  return events && filters && /*#__PURE__*/_jsx(ContentList, {
    "data-testid": "contentList--module-".concat(id),
    items: events,
    filterBarTitle: t('FRODOR_8931db', 'Upcoming events', ''),
    filters: filters,
    filterBarColor: gray90,
    emptyMessage: emptyMessage,
    showFilters: events.length > 1 || router.query._lqa === 'showFilters'
  }) || /*#__PURE__*/_jsx(LoadingIndicator, {});
};